import React from 'react';
import { ToggleStyles as S } from './Toggle.styles';
const Toggle = ({ label, value, onChange }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Label, null, label),
        React.createElement(S.ToggleWrapper, { active: value, onClick: () => onChange(!value) },
            React.createElement(S.ToggleBall, { active: value }))));
};
export default Toggle;
